<div class="coupon-selection">
  <input type="text" placeholder="Enter your code" />
  <button type="submit" class="apply">{{'apply'|translate}}</button>
</div>
